import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../utils/api";
import { showToast } from "./toastSlice";

const initialState = {
  list: [],
};

// Driver List
export const getContactFormList = createAsyncThunk(
  "contactForm/get_list",
  async ({ hidePageLoader }, { dispatch }) => {
    try {
      const res = await api("get", "/contact");
      if (res.success && res.data) {
        dispatch(contactFormSlice.actions.setContactForms(res.data));
        return res.data;
      } else {
        dispatch(contactFormSlice.actions.setContactForms(res.data));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
        hidePageLoader(dispatch);
    }
  }
);

const contactFormSlice = createSlice({
  name: "contactForm",
  initialState,
  reducers: {
    setContactForms: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { setContactForms } = contactFormSlice.actions;

export default contactFormSlice.reducer;
